import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate, useParams } from "react-router-dom";
import Style from "./VideoDetails.module.css";
import { useQuery } from "react-query";
import axios from "axios";
import { BallTriangle } from "react-loader-spinner";
import { toast } from "react-toastify";
import ReactPlayer from "react-player";

const VideoDetails = () => {
  const notify = (mess, type) => {
    toast[type](mess);
  };
  const [VideoDetails, setVideoDetails] = useState(null);
  const [Error, setError] = useState(null);
  const [loading, setloading] = useState(false);
  const [phone, setphone] = useState(null);
  let { id, name, courseId } = useParams();
  function Subscriptions() {
    return axios
      .post(
        `https://itc-541ea27f6158.herokuapp.com/api/v1/subscription/${courseId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        }
      )
      .then((response) => {
        notify("تم أرسال طلبك للمسؤول", "warn");
        // return response.data; // Assuming response.data contains subscription data
      })
      .catch((error) => {
        // Handle error
        notify(error.response.data.message, "error");
        console.error("Error fetching subscription data:", error);
        setloading(false);
        if (error.response.status === 405) {
          setloading(false);
          navigate("/login");
          notify(error.response.data.message, "success");
        }
        throw error; // Propagate the error for the caller to handle
      });
  }
  let navigate = useNavigate();
  const [phonewhats, setphoneWhats] = useState(null);
  const [phonetele, setphonetele] = useState(null);
  const [quizData, setQuizData] = useState([]); // ✅ State جديد للـ Quiz

  useEffect(() => {
    const fetchData = async () => {
      try {
        setloading(true);
        const response = await axios.get(
          `https://itc-541ea27f6158.herokuapp.com/api/v1/subject-video/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            },
          }
        );
        setloading(false);
        setVideoDetails(response?.data.data);
        fetchQuiz(response?.data?.data?.videoId);
      } catch (error) {
        setloading(false);
        if (error?.response.status === 400) {
          setError(error.response.data.message);
        }
        if (error.response.status === 405) {
          setloading(false);
          navigate("/login");
          notify(error.response.data.message, "success");
        }

        console.error("Error fetching course data:", error);
        // Handle error
      }
    };

    const getPhone = async () => {
      try {
        setloading(true);
        const response = await axios.get(
          `https://itc-541ea27f6158.herokuapp.com/api/v1/technical-support/phone-number`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            },
          }
        );
        setloading(false);
        setphoneWhats(response?.data?.data.whatsapp);
        setphonetele(response?.data?.data.telegram);
      } catch (error) {
        if (error.response.status == 400) {
        }

        console.error("Error fetching course data:", error);
        // Handle error
      }
    };
    const fetchQuiz = async (videoId) => {
      try {
        const quizResponse = await axios.get(
          `https://itc-541ea27f6158.herokuapp.com/api/v2/quizzes?videoId=${videoId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            },
          }
        );

        setQuizData(quizResponse?.data?.data);
        console.log(quizResponse);
      } catch (error) {
        console.error("Error fetching quiz data:", error);
      }
    };
    getPhone();
    fetchData();
  }, [id, navigate]);
  const [playing, setPlaying] = useState(false);

  const togglePlay = () => {
    setPlaying(!playing);
  };

  return (
    <>
      <Helmet>
        <title>المشاهدة </title>
      </Helmet>

      {Error != null ? (
        <>
          {loading ? (
            <>
              <div className={`${Style.home2} w-full flex justify-center`}>
                <BallTriangle
                  height={100}
                  width={100}
                  radius={5}
                  color="#4fa94d"
                  ariaLabel="ball-triangle-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={true}
                />
              </div>
            </>
          ) : (
            <>
              <div
                className={`${Style.home} bg-gray-100 min-h-screen     rounded-tr-3xl `}
              >
                <div className="bg-white grid   xl:grid-cols-2 items-center lg:grid-cols-3 md:grid-cols-2  sm:grid-cols-2 max-sm:w-12/12 text-center p-5 w-9/12 m-auto max-sm:w-9/12  rounded-xl mt-5">
                  <div className="text-darkgreen font-bold  text-2xl max-sm:text-sm flex flex-col max-sm:text-start ">
                    <p>لمشاهدة جميع الفيدوهات</p>
                    <p className="text-end   ">يجب ان تشترك اولا</p>
                  </div>
                  <div>
                    <button
                      onClick={() =>
                        document.getElementById("my_modal_2").showModal()
                      }
                      className="bg-yellowCustom btn-ghost max-sm:px-12 max-sm:mt-2 max-sm:py-2 max-sm:text-lg   hover:bg-yellow-400 text-white p-5 px-24 text-3xl rounded-xl"
                    >
                      اشترك الأن
                    </button>

                    <dialog id="my_modal_2" className="modal">
                      <div className="modal-box">
                        <h3 className="font-bold text-lg mb-4">
                          {" "}
                          قم بتأكيد الطلب ثم تواصل مع المسؤول
                        </h3>
                        {phonewhats || phonetele ? (
                          <>
                            <div
                              className={`grid grid-cols-1 ${Style.wwww} w-8/12 mx-auto `}
                            >
                              <Link
                                to={`https://wa.me/+2${phonewhats}`}
                                className="btn mb-2 hover:border-customGreen  bg-white  border-customGreen"
                              >
                                <h3 className={`text-lg ${Style.font_wha} `}>
                                  {phonewhats}
                                </h3>
                                <svg
                                  className={Style.svgs}
                                  width="29"
                                  height="29"
                                  viewBox="0 0 35 35"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g filter="url(#filter0_d_110_458)">
                                    <path
                                      d="M3.61863 14.3742C3.61795 16.8188 4.25958 19.2058 5.47962 21.3098L3.50195 28.4983L10.8915 26.5694C12.9354 27.6771 15.2254 28.2575 17.5525 28.2577H17.5586C25.2407 28.2577 31.4942 22.0344 31.4975 14.3851C31.499 10.6785 30.0503 7.19304 27.4183 4.57077C24.7868 1.94873 21.287 0.503958 17.558 0.502266C9.87493 0.502266 3.62192 6.72524 3.61875 14.3742"
                                      fill="url(#paint0_linear_110_458)"
                                    />
                                    <path
                                      d="M3.12121 14.3695C3.12042 16.9021 3.78504 19.3745 5.04858 21.5537L3 29L10.6545 27.0019C12.7636 28.1467 15.1382 28.7503 17.5545 28.7512H17.5607C25.5185 28.7512 31.9966 22.304 32 14.381C32.0014 10.5412 30.5006 6.93042 27.7746 4.21421C25.0483 1.49834 21.4233 0.00157886 17.5607 0C9.60158 0 3.12438 6.44627 3.12121 14.3695ZM7.67965 21.1784L7.39384 20.7268C6.19238 18.8249 5.55823 16.6271 5.55914 14.3704C5.56174 7.78481 10.9453 2.42694 17.5653 2.42694C20.7711 2.42829 23.7839 3.67244 26.05 5.92976C28.316 8.18731 29.5629 11.1883 29.5621 14.3801C29.5591 20.9656 24.1754 26.3242 17.5607 26.3242H17.556C15.4021 26.323 13.2898 25.7472 11.4476 24.659L11.0092 24.4002L6.46686 25.5858L7.67965 21.1783V21.1784Z"
                                      fill="url(#paint1_linear_110_458)"
                                    />
                                    <path
                                      d="M13.9527 8.3625C13.6824 7.76445 13.398 7.75238 13.1409 7.74189C12.9304 7.73287 12.6898 7.73355 12.4495 7.73355C12.2088 7.73355 11.8179 7.82366 11.4875 8.18285C11.1567 8.54238 10.2246 9.4112 10.2246 11.1783C10.2246 12.9455 11.5175 14.6533 11.6977 14.8931C11.8782 15.1326 14.1936 18.8749 17.8608 20.3146C20.9085 21.511 21.5287 21.2731 22.1902 21.2131C22.8517 21.1533 24.3248 20.3445 24.6254 19.5058C24.9261 18.6672 24.9261 17.9483 24.836 17.7981C24.7458 17.6485 24.5052 17.5586 24.1444 17.379C23.7835 17.1994 22.0097 16.3305 21.679 16.2106C21.3483 16.0908 21.1078 16.031 20.8672 16.3907C20.6265 16.7498 19.9356 17.5586 19.7251 17.7981C19.5147 18.0382 19.3041 18.0681 18.9434 17.8885C18.5824 17.7082 17.4205 17.3294 16.0419 16.1059C14.9694 15.1539 14.2453 13.9782 14.0348 13.6185C13.8243 13.2595 14.0123 13.0648 14.1932 12.8858C14.3553 12.7249 14.5541 12.4664 14.7347 12.2568C14.9146 12.047 14.9746 11.8973 15.0949 11.6578C15.2153 11.4181 15.1551 11.2083 15.065 11.0286C14.9746 10.849 14.2735 9.07265 13.9527 8.3625Z"
                                      fill="white"
                                    />
                                  </g>
                                  <defs>
                                    <filter
                                      id="filter0_d_110_458"
                                      x="0"
                                      y="0"
                                      width="35"
                                      height="35"
                                      filterUnits="userSpaceOnUse"
                                      colorInterpolationFilters="sRGB"
                                    >
                                      <feFlood
                                        floodOpacity="0"
                                        result="BackgroundImageFix"
                                      />
                                      <feColorMatrix
                                        in="SourceAlpha"
                                        type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                        result="hardAlpha"
                                      />
                                      <feOffset dy="3" />
                                      <feGaussianBlur stdDeviation="1.5" />
                                      <feComposite
                                        in2="hardAlpha"
                                        operator="out"
                                      />
                                      <feColorMatrix
                                        type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                                      />
                                      <feBlend
                                        mode="normal"
                                        in2="BackgroundImageFix"
                                        result="effect1_dropShadow_110_458"
                                      />
                                      <feBlend
                                        mode="normal"
                                        in="SourceGraphic"
                                        in2="effect1_dropShadow_110_458"
                                        result="shape"
                                      />
                                    </filter>
                                    <linearGradient
                                      id="paint0_linear_110_458"
                                      x1="1403.28"
                                      y1="2800.11"
                                      x2="1403.28"
                                      y2="0.502266"
                                      gradientUnits="userSpaceOnUse"
                                    >
                                      <stop stopColor="#1FAF38" />
                                      <stop offset="1" stopColor="#60D669" />
                                    </linearGradient>
                                    <linearGradient
                                      id="paint1_linear_110_458"
                                      x1="1453"
                                      y1="2900"
                                      x2="1453"
                                      y2="0"
                                      gradientUnits="userSpaceOnUse"
                                    >
                                      <stop stopColor="#F9F9F9" />
                                      <stop offset="1" stopColor="white" />
                                    </linearGradient>
                                  </defs>
                                </svg>
                              </Link>
                              <Link
                                to={phonetele}
                                className="btn hover:border-customGreen  bg-white  border-customGreen"
                              >
                                <h3 className={`text-lg ${Style.font_wha} `}>
                                  {phonetele}
                                </h3>
                                <svg
                                  className={Style.svgs}
                                  width="29"
                                  height="29"
                                  viewBox="0 0 29 29"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clipPath="url(#clip0_441_26)">
                                    <path
                                      d="M14.5 0C10.6552 0 6.96453 1.52862 4.24805 4.24691C1.52876 6.96629 0.000753252 10.6543 0 14.5C0 18.3441 1.5293 22.0348 4.24805 24.7531C6.96453 27.4714 10.6552 29 14.5 29C18.3448 29 22.0355 27.4714 24.752 24.7531C27.4707 22.0348 29 18.3441 29 14.5C29 10.6559 27.4707 6.96521 24.752 4.24691C22.0355 1.52862 18.3448 0 14.5 0Z"
                                      fill="url(#paint0_linear_441_26)"
                                    />
                                    <path
                                      d="M6.56279 14.347C10.7904 12.5055 13.6089 11.2914 15.0181 10.7048C19.0464 9.02985 19.8824 8.73895 20.4284 8.72909C20.5485 8.72716 20.8158 8.75684 20.9903 8.89788C21.1353 9.01682 21.1761 9.17768 21.1965 9.29063C21.2146 9.40345 21.2395 9.6606 21.2191 9.86134C21.0016 12.1541 20.0568 17.7181 19.5765 20.2862C19.3749 21.3728 18.9739 21.7371 18.5865 21.7726C17.7436 21.8501 17.1047 21.2162 16.2891 20.6817C15.0136 19.845 14.2931 19.3244 13.0538 18.5081C11.6219 17.5647 12.5508 17.0461 13.3665 16.1987C13.5794 15.9769 17.2905 12.6023 17.3608 12.2962C17.3698 12.2579 17.3789 12.1152 17.2928 12.04C17.209 11.9645 17.0843 11.9903 16.9937 12.0107C16.8646 12.0397 14.8278 13.3873 10.8765 16.0533C10.2988 16.4507 9.77544 16.6444 9.30419 16.6342C8.78763 16.6231 7.79076 16.3415 7.0499 16.1009C6.14365 15.8057 5.42091 15.6496 5.48435 15.1482C5.51607 14.8872 5.8763 14.6201 6.56279 14.347Z"
                                      fill="white"
                                    />
                                  </g>
                                  <defs>
                                    <linearGradient
                                      id="paint0_linear_441_26"
                                      x1="1450"
                                      y1="0"
                                      x2="1450"
                                      y2="2900"
                                      gradientUnits="userSpaceOnUse"
                                    >
                                      <stop stopColor="#2AABEE" />
                                      <stop offset="1" stopColor="#229ED9" />
                                    </linearGradient>
                                    <clipPath id="clip0_441_26">
                                      <rect
                                        width="29"
                                        height="29"
                                        fill="white"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </Link>
                            </div>
                          </>
                        ) : (
                          <>
                            <Link className="btn hover:border-customGreen w-8/12 bg-white  border-customGreen">
                              <h3 className="text-2xl">
                                لا يوجد رقم تواصل الان
                              </h3>
                            </Link>
                          </>
                        )}

                        <div className="modal-action">
                          <form method="dialog" className="mx-auto">
                            {/* if there is a button in form, it will close the modal */}
                            <button
                              onClick={Subscriptions}
                              className="py-2.5 px-5  text-sm font-medium text-white  bg-customGreen rounded-lg border border-gray-200 hover:bg-green-700   "
                            >
                              تأكيد الطلب
                            </button>
                            <button className="text-white ms-3 bg-red-600 hover:bg-red-800  font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center">
                              الغاء الطلب
                            </button>
                          </form>
                        </div>
                      </div>
                    </dialog>
                  </div>
                </div>
              </div>
            </>
          )}{" "}
        </>
      ) : (
        <>
          <div>
            {loading ? (
              <>
                <div className={`${Style.home2} w-full flex justify-center`}>
                  <BallTriangle
                    height={100}
                    width={100}
                    radius={5}
                    color="#4fa94d"
                    ariaLabel="ball-triangle-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                  />
                </div>
              </>
            ) : (
              <>
                <div
                  className={`${Style.home} bg-gray-100 min-h-screen     rounded-tr-3xl    `}
                >
                  <div className="  flex items-center bg-white p-5 rounded-xl my-5">
                    <div className="flex items-center">
                      <Link to={"/"} className="mr-2 text-green-500">
                        {name}
                      </Link>
                    </div>
                    <div className="flex items-end pt-1">
                      <span className="px-2">
                        <svg
                          width="9"
                          height="10"
                          viewBox="0 0 10 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.85398 0.319999V2.3L2.67398 5.36L8.85398 8.06V10.02L0.173984 6.04V4.84L8.85398 0.319999Z"
                            fill="#009539"
                            fillOpacity="0.7"
                          />
                        </svg>
                      </span>
                    </div>
                    <Link
                      to={`/${name}/${courseId}/subjects`}
                      className="text-green-500"
                    >
                      {VideoDetails?.subjectTitle}
                    </Link>
                    <div className="flex items-end pt-1">
                      <span className="px-2">
                        <svg
                          width="9"
                          height="10"
                          viewBox="0 0 10 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.85398 0.319999V2.3L2.67398 5.36L8.85398 8.06V10.02L0.173984 6.04V4.84L8.85398 0.319999Z"
                            fill="#009539"
                            fillOpacity="0.7"
                          />
                        </svg>
                      </span>
                    </div>
                    <Link
                      to={`/${name}/${courseId}/${VideoDetails?.subjectTitle}/${VideoDetails?.subjectId}/Videos`}
                      className="text-green-500"
                    >
                      {VideoDetails?.videoTitle}
                    </Link>
                  </div>
                  <div
                    key={VideoDetails?.videoId}
                    className="grid  gap-x-5 xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3  sm:grid-cols-3 bg-white p-5 rounded-xl my-5 max-sm:px-5 px-10"
                  >
                    <div className="flex flex-col max-lg:col-span-3 max-lg:pt-2 w-full ">
                      <h1 className="font-bold text-xl ">
                        {VideoDetails?.videoTitle}
                      </h1>
                      <p
                        className="p-3 text-xl text-customGray"
                        style={{ letterSpacing: "1px" }}
                      >
                        {VideoDetails?.videoDescription}{" "}
                      </p>
                      <hr className={`${Style.hr} bg-green-500 mt-2 `} />
                    </div>
                    <div className="col-span-2 max-lg:col-span-3 max-lg:order-first max-sm:pb-5">
                      <div>
                        {/* <iframe
        className="video-player"
        width="560"
        height="315"
        src={`https://www.youtube.com/embed/${videoId}`}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe> */}
                      </div>

                      <ReactPlayer
                        url={VideoDetails?.videoUrl}
                        width="100%"
                        height={415}
                        config={{
                          youtube: {
                            playerVars: {
                              autoplay: 1,
                              controls: 1,
                              modestbranding: 1,
                              rel: 0,
                              showinfo: 0,
                            },
                          },
                        }}
                      />
                    </div>
                  </div>

                  <div className={`   `}></div>
                  {/* {Exames.map((exam)=>{
  return ()
} */}
                  <div className="grid grid-cols-12 gap-3">
                    {VideoDetails?.haveQuiz &&
                      quizData?.map(
                        (quiz) => (
                          // quiz?.isSolved ? (
                          <div
                            key={quiz?.quizId}
                            className=" col-span-4 flex flex-col justify-between  p-4 bg-white border border-gray-200 rounded-lg shadow"
                          >
                            <div className="flex items-center justify-between pt-3">
                              <h5 className="mb-2 text-lg font-bold text-progress_text">
                                {quiz?.quizTitle}
                              </h5>
                            </div>

                            <p className="text-gray-400 mb-5">
                              {quiz?.quizDescription}
                            </p>

                            {quiz.isSolved ? (
                              <>
                                <div className="text-center">
                                  <p>
                                    {quiz?.totalScore}/
                                    <span
                                      className={`
              ${
                quiz?.solutionPercentage <= 50
                  ? "text-error"
                  : quiz?.solutionPercentage <= 75
                  ? "text-customGreen"
                  : "text-info"
              }
              font-bold pe-1 text-xl
            `}
                                    >
                                      {quiz?.actualScore}
                                    </span>
                                  </p>
                                </div>

                                <div className="text-center mt-2">
                                  <progress
                                    className={`
            progress w-11/12
            ${
              quiz?.solutionPercentage <= 50
                ? "progress-error"
                : quiz?.solutionPercentage <= 75
                ? "progress-success"
                : "progress-info"
            }
          `}
                                    value={quiz?.solutionPercentage}
                                    max="100"
                                  ></progress>
                                </div>

                                <div className="flex justify-center gap-8 mt-4">
                                  <Link
                                    to={`/ExmasDetails/${quiz?.quizId}`}
                                    className="px-4 py-2 rounded-2xl shadow-md bg-blue-500 text-white text-center hover:bg-blue-600 transition"
                                  >
                                    عرض الاجابات
                                  </Link>
                                  <Link
                                    to={`/Quiz/${quiz?.quizId}`}
                                    className="px-4 py-2 rounded-2xl shadow-md bg-green-500 text-white text-center hover:bg-green-600 transition"
                                  >
                                    إعادة الاختبار
                                  </Link>
                                </div>
                              </>
                            ) : (
                              <>
                                <Link
                                  to={`/Quiz/${quiz?.quizId}`}
                                  className="btn btn-ghost w-[40%] bg-customGreen text-white hover:bg-green-800"
                                >
                                  عرض الاختبار
                                </Link>
                              </>
                            )}
                          </div>
                        )
                        //  : (
                        //   <div
                        //     key={quiz._id}
                        //     className="w-4/12 max-sm:w-full py-5 px-5 bg-white border border-gray-200 rounded-lg shadow"
                        //   >
                        //     <div className="flex items-center justify-between pt-2">
                        //       <h5 className="mb-1 text-lg font-medium tracking-tight text-gray-900">
                        //         اختبر نفسك
                        //       </h5>
                        //     </div>

                        //     <div className="grid gap-5 xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-3">
                        //       <h5 className="mb-2 col-span-2 tracking-tight text-customGray">
                        //         في حال دخولك إلى الاختبار سيتم إظهار النتيجة بعد
                        //         الاختبار مباشرةً
                        //       </h5>

                        //       <Link
                        //         to={`/Quiz/${VideoDetails?.videoId}`}
                        //         className="btn btn-ghost bg-customGreen text-white hover:bg-green-800"
                        //       >
                        //         عرض الاختبار
                        //       </Link>
                        //     </div>
                        //   </div>
                        // )
                      )}
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default VideoDetails;
